import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { useCallback } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import {
  IAddCreatorsToScriptGenerateRequestPayload,
  IAIWorkspaceRequest,
} from "../types";

const QUERY_OPTIONS = {
  queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUESTS],
  skipInvalidation: false,
};

export function useAddCreatorsToScriptGenerateRequest(
  onSuccess?: (data: BackednResponse<IAIWorkspaceRequest>) => void
) {
  const addCreatorsToScriptGenerateRequest = useCallback(
    (payload: IAddCreatorsToScriptGenerateRequestPayload) =>
      AiWorkspaceService.addCreatorsToScriptGenerateRequest(payload)
        .then((res) => {
          ToastService.success("Creators added to the script request");
          return res;
        })
        .catch(async (err) => {
          let errorMessage = "Failed to add creators";
          if (err?.response) {
            try {
              const responseBody = await err.response.json();
              if (responseBody?.msg) errorMessage = responseBody.msg;
            } catch (e) {}
          }
          ToastService.error(errorMessage);
          throw err;
        }),
    []
  );

  const {
    mutate: addCreators,
    isLoading: isAdding,
    isSuccess: isAdded,
  } = useMutation<
    IAddCreatorsToScriptGenerateRequestPayload,
    BackednResponse<IAIWorkspaceRequest>
  >({
    mutationFn: addCreatorsToScriptGenerateRequest,
    options: QUERY_OPTIONS,
    onSuccess: (c, data) => {
      c.invalidateQueries({ queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUESTS] });
      c.invalidateQueries({ queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUEST] });
      onSuccess?.(data);
    },
  });

  return { addCreators, isAdding, isAdded };
}
